"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettifyTime = exports.getTimeElapsedSince = exports.getPrettyTimeElapsedSince = void 0;
const lodash_1 = __importDefault(require("lodash"));
const getPrettyTimeElapsedSince = (date) => {
    const diffInMs = (0, exports.getTimeElapsedSince)(date);
    return (0, exports.prettifyTime)(diffInMs);
};
exports.getPrettyTimeElapsedSince = getPrettyTimeElapsedSince;
const getTimeElapsedSince = (date) => {
    return new Date().getTime() - date.getTime();
};
exports.getTimeElapsedSince = getTimeElapsedSince;
const prettifyTime = (timeInMS) => {
    if (timeInMS >= 1000) {
        const diffInS = lodash_1.default.round(timeInMS / 1000, 1).toFixed(1);
        return `[${diffInS}s]`;
    }
    return `[${timeInMS}ms]`;
};
exports.prettifyTime = prettifyTime;
//# sourceMappingURL=getPrettyTimeElapsedSince.js.map